import { listPageStyles } from "../../styles/shared/listPageStyles";
import React from "react";
import { Box } from "@mui/material";

// Keep every tab-view sidebar aligned with the Companies page.

/**
 * Reusable page shell:
 * - Breadcrumb
 * - Optional stats section
 * - Optional header section
 * - Main content
 * - Optional right sidebar
 *
 * New slot props let pages compose their own sections while keeping a shared shell.
 * Legacy props are still supported so older usages keep working during the refactor.
 */
export default function ListTableTabsTemplate({
  breadcrumb,

  statsSection,
  headerSection,
  contentSection,
  footerSection,

  // Legacy props kept for compatibility.
  statsSlider,
  showStats = true,
  viewMode = "list",
  listContent,
  tabsContent,

  rightSidebar,

  rootSx,
  shellSx,
  layoutSx,
  leftColumnSx,
  rightSidebarSx,
  statsWrapperSx,
  headerWrapperSx,
  contentWrapperSx,
  footerWrapperSx }) {
  const isTabs = viewMode === "tabs";

  const resolvedStatsSection =
    statsSection ?? (showStats && statsSlider ? statsSlider : null);

  const resolvedHeaderSection = headerSection ?? null;

  const resolvedContentSection =
    contentSection ?? (isTabs ? tabsContent : listContent);
  const shellClassName = rightSidebar ? undefined : "main-border-radius";
  const leftColumnClassName = rightSidebar
    ? "tab-content-column main-border-radius"
    : "tab-content-column";
  const resolvedShellSx = listPageStyles.resolveShell({ rightSidebar, shellSx });

  return (
    <Box sx={listPageStyles.root({ rootSx })}>
      {breadcrumb ? <Box sx={listPageStyles.breadcrumb()}>{breadcrumb}</Box> : null}

      <Box
        className={shellClassName}
        sx={listPageStyles.shell({ resolvedShellSx })}
      >
        <Box
          sx={listPageStyles.layout({ layoutSx })}
        >
          <Box
            className={leftColumnClassName}
            sx={listPageStyles.contentColumn({ leftColumnSx })}
          >
            {resolvedStatsSection ? (
              <Box sx={listPageStyles.stats({ statsWrapperSx })}>
                {resolvedStatsSection}
              </Box>
            ) : null}

            {resolvedHeaderSection ? (
              <Box sx={headerWrapperSx}>{resolvedHeaderSection}</Box>
            ) : null}

            {resolvedContentSection ? (
              <Box sx={listPageStyles.content({ contentWrapperSx })}>
                {resolvedContentSection}
              </Box>
            ) : null}

            {footerSection ? (
              <Box sx={footerWrapperSx}>{footerSection}</Box>
            ) : null}
          </Box>

          {rightSidebar ? (
            <Box
              sx={listPageStyles.sidebar({ rightSidebarSx })}
            >
              {rightSidebar}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
